var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Tunisia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#dd2c00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,16c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S28.418,16,24,16z M24,30c-3.313,0-6-2.688-6-6 s2.688-6,6-6c1.914,0.004,3.715,0.918,4.84,2.469c-0.883-0.816-2.039-1.266-3.238-1.27c-2.652,0-4.801,2.148-4.801,4.801 s2.148,4.801,4.801,4.801c1.199-0.004,2.355-0.453,3.238-1.266C27.715,29.082,25.914,29.996,24,30z M28.512,26.117l-2.488-0.809 l-1.535,2.117v-2.617L22,24l2.488-0.809v-2.613l1.535,2.113l2.488-0.805L26.977,24L28.512,26.117z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Tunisia);
export default __webpack_public_path__ + "static/media/icons8-tunisia.ace660e4dab884af263cac286fd53b7f.svg";
export { ForwardRef as ReactComponent };